module.exports = "<svg viewBox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><path fill=\"#15cc5e\" d=\"M7.625,19.925 L2.225,14.525 C1.925,14.225 1.925,13.925 2.225,13.725 L3.525,12.425 C3.825,12.125 4.125,12.125 4.325,12.425 L7.825,15.925 C7.925,16.025 8.125,16.025 8.325,15.925 L20.025,4.225 C20.325,3.925 20.625,3.925 20.825,4.225 L22.125,5.525 C22.425,5.825 22.425,6.125 22.125,6.325 L8.425,20.025 C8.225,20.125 7.925,20.125 7.625,19.925 L7.625,19.925 Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ../~/@jg/styles/src/assets/icons/tick-green.svg
// module id = 860
// module chunks = 0